import styled from 'styled-components'

export const Title = styled.div`
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
`
